import React from "react";
import PropTypes from "prop-types";
import { TableCell, makeStyles } from "@material-ui/core";
import translate from "i18n/translate";
import { DISTRIBUTOR_TYPE } from "../constants";

export const useStyles = makeStyles((theme) => ({
  small: {
    fontSize: theme.typography.pxToRem(14),
  },
}));

const CommonHeaders = ({ isDetailTable, type }) => {
  const classes = useStyles();
  const smallClass = isDetailTable ? classes.small : "";
  return (
    <>
      {isDetailTable ? (
        <TableCell />
      ) : (
        <TableCell>{translate("distributors.referal")}</TableCell>
      )}
      <TableCell className={smallClass}>
        {translate("distributors.operations")}
      </TableCell>
      <TableCell className={smallClass}>
        {translate("distributors.transacted")}
      </TableCell>
      {!isDetailTable && type === DISTRIBUTOR_TYPE.master && (
        <TableCell>{translate("distributors.type")}</TableCell>
      )}
      <TableCell className={smallClass}>
        {translate("distributors.commisions")}
      </TableCell>
      {type === DISTRIBUTOR_TYPE.master && (
        <>
          <TableCell className={smallClass}>
            {translate("distributors.cost")}
          </TableCell>
          <TableCell className={smallClass}>
            {translate("distributors.net")}
          </TableCell>
        </>
      )}
      <TableCell className={smallClass}>
        {translate("distributors.distributor")}
      </TableCell>
    </>
  );
};

CommonHeaders.propTypes = {
  isDetailTable: PropTypes.bool,
  type: PropTypes.string.isRequired,
};

CommonHeaders.defaultProps = {
  isDetailTable: false,
};

export default CommonHeaders;
